import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth-context';
import api from '../../lib/api';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Baby, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function TrimesterSelect() {
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  const trimesters = [
    { value: 1, label: 'Trimester 1', desc: 'Weeks 1-12', color: 'border-teal-300 bg-teal-50' },
    { value: 2, label: 'Trimester 2', desc: 'Weeks 13-26', color: 'border-orange-300 bg-orange-50' },
    { value: 3, label: 'Trimester 3', desc: 'Weeks 27-40', color: 'border-rose-300 bg-rose-50' },
  ];

  const handleContinue = async () => {
    if (!selected) { toast.error('Please select your trimester'); return; }
    setLoading(true);
    try {
      await api.post(`/api/trial/set-trimester?trimester=${selected}`);
      await refreshUser();
      navigate('/learner/dashboard');
    } catch (err) {
      toast.error('Failed to set trimester');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <Baby className="h-12 w-12 text-primary mb-4" />
      <h1 className="font-heading text-3xl font-semibold text-center mb-2">Welcome to Soul Sanskar</h1>
      <p className="text-muted-foreground text-center mb-8">Which trimester are you in?</p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl w-full mb-6">
        {trimesters.map(t => (
          <button
            key={t.value}
            onClick={() => setSelected(t.value)}
            className={`p-6 rounded-2xl border-2 text-center transition-all duration-200 ${
              selected === t.value ? `${t.color} shadow-md scale-[1.02]` : 'border-border bg-white hover:bg-muted/40'
            }`}
            data-testid={`trimester-${t.value}`}
          >
            <p className="text-lg font-semibold">{t.label}</p>
            <p className="text-sm text-muted-foreground">{t.desc}</p>
          </button>
        ))}
      </div>

      <Button onClick={handleContinue} disabled={!selected || loading} size="lg" data-testid="trimester-continue">
        {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
        Continue
      </Button>
    </div>
  );
}
